import { Breadcrumbs } from '@loadsmart/loadsmart-ui'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getInstallation } from 'services/kraken-core/installations/installations.service'
import { InstallationDetail as InstallationDetailType } from 'common/types/kraken-core/Installation'
import { Grid, Box } from '@mui/material'
import useTopNavigationContext from 'hooks/useTopNavigationContext/useTopNavigationContext'
import { getIntegrationModule } from 'services/kraken-core/integration_module/integration.service'
import { ROUTES } from 'routing/routes'
import { IntegrationModule } from 'common/types/kraken-core/IntegrationModule'
import InstallationDetailContainer from './InstallationDetailContainer'
import Loading from 'atoms/Loading'

export interface InstallationDetailProps {
  id?: string
}

export default function InstallationDetailPage(props: InstallationDetailProps) {
  const { id: idFromParams } = useParams<{ id: string }>()
  const [installation, setInstallation] = useState<InstallationDetailType>()
  const [integrationModule, setIntegrationModule] = useState<IntegrationModule>()
  const topNavigation = useTopNavigationContext()

  useEffect(() => {
    const idToFetch = idFromParams || props.id
    if (idToFetch) {
      getInstallation(idToFetch)
        .then(response => {
          response.response && setInstallation(response.response.data)
        })
        .catch(error => {
          console.error('Error getting installation')
        })
    }
  }, [idFromParams, props.id])

  useEffect(() => {
    if (!installation) return

    // Fetch int module
    if (installation.integration_module) {
      getIntegrationModule(installation.integration_module)
        .then(response => {
          response.response && setIntegrationModule(response.response.data)
        })
        .catch(error => {
          console.error('Error getting integration module')
        })
    }

    // Update top navigation
    topNavigation.updateState({
      children: (
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Box display="flex" alignItems="center">
              <Breadcrumbs
                entries={[
                  { label: 'Installations', active: false, url: ROUTES.INSTALLATIONS },
                  { label: installation.name || idFromParams || '', active: true },
                ]}
              />
            </Box>
          </Grid>
        </Grid>
      ),
    })
  }, [installation?.id])

  return (
    <>
      {!installation || !integrationModule ? <Loading /> : null}

      {installation && integrationModule ? (
        <InstallationDetailContainer
          installation={installation}
          integrationModule={integrationModule}
        />
      ) : null}
    </>
  )
}
